module.exports = __webpack_public_path__ + "ui-static/img/export-border-right.d0c994eb.svg";